import router from '../router'
import VueTk from '@moke/vue-tk'
import store from '../store/index'
import { Toast } from 'vant'

// 微信登录
async function wxLogin (code) {
  Toast.loading({
    duration: 0,
    message: '加载中...',
    forbidClick: true,
  })
  let { data: res } = await VueTk.tkParse.post('/wxlogin', { code })
  if (!res || (res && !res.status) || res.status !== 'success') {
    Toast.fail('保存失败')
    Toast.clear()
    // eslint-disable-next-line no-throw-literal
    throw res.message || '登录失败'
  }
  if (res.status === 'success') {
    store.commit('setSessionToken', res.data.sessionToken)
    store.commit('setUser', res.data.user)
  }
  Toast.clear()
}
const rulers = [
  {
    match: '*',
    handler: async function (route, next) { // 路由鉴权方法
      const routePaths = [
        '/', // 首页
        '/auth/blank', // 空白页面
        '/auth/scan', // 二维码页面
        '/auth/login', // 登录页
        '/article/protocol', // 协议页面
        '/article/detail', // 详情页面
        '/common/search', // 搜索页面
        '/course/courseDetail', // 课的详情
        '/exchange/exchange', // 兑换页面
        '/auth/token-debug', // token 调试登录页
      ]
      const { code: wxCode } = route.query
      if (routePaths.includes(route.path)) {
        if (!store.getters.isLogin && wxCode) {
          await wxLogin(wxCode)
        }
        next(true)
      } else {
        if (store.getters.isLogin) {
          next(true)
        } else { // 未登录状态下的用户鉴权
          if (wxCode) {
            await wxLogin(wxCode)
            next(true)
          } else {
            if (VueTk.tkUa.isWechat) {
              next('/auth/login?type=login')
            } else {
              next('/auth/scan')
            }
          }
        }
      }
    },
    // 禁止访问的跳转地址，优先级低于handler中返回的地址
    fallbackUrl: '/auth/login'
  }
]

VueTk.tkRouterAuth.init(rulers, router)
